<div class="about-us-container">
    <span id="titleAbout">{{'LANDING_PAGE.ABOUT_US_TITTLE' | translate}}</span>
    <div class="about-us-content">
        <div class="about-us-image">
            <img src="../../../../../assets/images/Ovadyah.jpg" alt="About Us Image" />
        </div>
        <div class="about-us-text">
            <p [innerHTML]="'LANDING_PAGE.ABOUT_US_CONTENT' | translate"></p>
        </div>
    </div>
    <app-display-cards [cardData]="cardsAboutUsContent"></app-display-cards>
</div>
